import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";
import { BULK_DELETE, HEALTH_PLANS } from "constants/endpoints";
import { toast } from "react-toastify";
import { deleteApi, get, post, put } from "services/network";
import { converyQueryObjectToFilterString } from "utils/common";

export const getLcmHealthPlans = async (meta) => {
  try {
    const result = await get(
      `${HEALTH_PLANS}${`?${converyQueryObjectToFilterString(meta)}`}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getLcmHealthPlanById = async (id) => {
  try {
    const result = await get(`${HEALTH_PLANS}/${id}`, true);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const addLcmHealthPlan = async (data, setErrors = () => {}) => {
  try {
    const result = await post(`${HEALTH_PLANS}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="HealthPlan created successfully"
      />,
    );
    return result;
  } catch (error) {
    const errors = error?.response?.data?.errors;

    if (errors) {
      setErrors(errors);
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorMessage = Array.isArray(errors[firstErrorKey])
        ? errors[firstErrorKey][0]
        : errors[firstErrorKey];

      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={`${firstErrorKey.toUpperCase()} ${firstErrorMessage}`}
        />,
      );
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message="Something went wrong"
        />,
      );
    }
    console.log(error);
  }
};

export const updateLcmHealthPlan = async (data, id, setErrors = () => {}) => {
  try {
    const result = await put(
      `${HEALTH_PLANS}/${data?.health_plan?.id}`,
      data,
      true,
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="HealthPlan updated successfully"
      />,
    );
    return result;
  } catch (error) {
    const errors = error?.response?.data?.errors;

    if (errors) {
      setErrors(errors);
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorMessage = Array.isArray(errors[firstErrorKey])
        ? errors[firstErrorKey][0]
        : errors[firstErrorKey];

      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={`${firstErrorKey.toUpperCase()} ${firstErrorMessage}`}
        />,
      );
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message="Something went wrong"
        />,
      );
    }

    console.log(error);
  }
};

export const deleteLcmHealthPlan = async (id) => {
  try {
    const result = await deleteApi(`${HEALTH_PLANS}/${id}`, true);
    toast(<CustomToast variant={alertTypes.INFO} message={result.message} />);

    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "Error"}
      />,
    );
    console.log(error);
  }
};

export const deleteBulkHealthPlans = async (data) => {
  try {
    const result = await put(`${HEALTH_PLANS}/${BULK_DELETE}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Health Plan deleted successfully"
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
  }
};
